import React from 'react';
import {Box, Grid, CircularProgress} from '@mui/material';
import {ParticipationBuildupChart} from '../../DashboardCommon/ParticipationBuildupChart.comp';
import {PageHeader, StatCard, GuidanceBanner} from '../components/widgets.comp';
import CircularLoader from '../../../components/CircularLoader';
import NoDataAvailable from '../../../components/NoDataAvailable';
import {useDashboard} from '../../../context/DashboardContext';
import {findCard, whole, titleCase} from '../networkData';

/* Slide 29 — Participation Overview (SND-29-01 … 05).

     SND-29-01  Children Assessed    SND.S_9.C_3   KPICard
     SND-29-02  Schools Assessed     SND.S_9.C_4   KPICard
     SND-29-03  Coverage Rate        SND.S_9.C_2   KPICard (kpi_value %)
     SND-29-04  Data Confidence      SND.S_9.C_2   the same card's kpi_band
     SND-29-05  Participation build-up  SND.S_9.C_5  TrendLineCard (y_min … y_max)

   The "Target: N" sub-line is left off per the deck's "Remove target 'of XX'."
   note on this slide. */
const PARTICIPATION_SECTION_CODE = 'S_9';
const CARD_SECTIONS = [PARTICIPATION_SECTION_CODE];

const ParticipationOverviewTab = () => {
    const {dashboardData, loading} = useDashboard({ card_sections: CARD_SECTIONS });

    if (loading) {
        return <CircularLoader />;
    }

    if (!dashboardData) {
        return <NoDataAvailable />;
    }
    const coverage = findCard(dashboardData, PARTICIPATION_SECTION_CODE, 'C_2');
    const children = findCard(dashboardData, PARTICIPATION_SECTION_CODE, 'C_3');
    const schools = findCard(dashboardData, PARTICIPATION_SECTION_CODE, 'C_4');
    const trend = findCard(dashboardData, PARTICIPATION_SECTION_CODE, 'C_5');

    const KPI_CARDS = [
        children && {label: titleCase(children.kpi_name) || 'Children Assessed', value: whole(children.kpi_value).toLocaleString()},
        schools && {label: titleCase(schools.kpi_name) || 'Schools Assessed', value: String(whole(schools.kpi_value))},
        coverage && {label: 'Coverage Rate', value: `${whole(coverage.kpi_value)}%`},
        coverage?.kpi_band && {label: 'Data Confidence', value: coverage.kpi_band},
    ].filter(Boolean);

    return (
    <Box>
        <PageHeader
            title="Participation Overview"
            subtitle="Is network assessment coverage representative enough to guide policy?"
        />

        <Grid container spacing={2.5} sx={{mb: 3}}>
            {KPI_CARDS.map((kpi) => (
                <Grid item xs={12} sm={6} md={3} key={kpi.label}>
                    <StatCard {...kpi}/>
                </Grid>
            ))}
        </Grid>

        {/* Bars = learners added in the month, line = running total (QA 9 Oct: a single month must still show). */}
        <ParticipationBuildupChart card={trend} sx={{mb: 3}}/>

        <GuidanceBanner
            label="Decision Guidance:"
            text={[
                'If participation is uneven by school, interpret comparisons cautiously.',
                'Before acting on weak scores, check whether the sample is representative.',
            ]}
        />
    </Box>
    );
};

export default ParticipationOverviewTab;
